import { Input } from '@arco-design/web-react'

interface Props {
  value: string
  onChange: (v: string) => void
  placeholder?: string
  rows?: number
  readOnly?: boolean
}

/**
 * JSON 文本编辑器（无 Monaco，靠 TextArea + 保存前校验）。
 */
export default function JsonField({ value, onChange, placeholder, rows = 8, readOnly }: Props) {
  return (
    <Input.TextArea
      value={value}
      onChange={readOnly ? undefined : onChange}
      readOnly={readOnly}
      placeholder={placeholder}
      autoSize={{ minRows: rows, maxRows: rows * 3 }}
      style={{ fontFamily: 'ui-monospace, SFMono-Regular, Menlo, monospace', fontSize: 12 }}
    />
  )
}

export function validateJson(v: string): string | null {
  if (!v || !v.trim()) return null
  try {
    JSON.parse(v)
    return null
  } catch (e) {
    return e instanceof Error ? `JSON 解析失败：${e.message}` : 'JSON 解析失败'
  }
}
